export function CosaFacciamo() {
  const servizi = [
    {
      icon: '📊',
      title: 'Integriamo Tutti gli Indicatori',
      description: 'Raccogliamo e unifichiamo tutti i KPI esistenti - finanziari, di mercato, reputazionali e digitali - in un\'unica metodologia coerente seguendo e integrando l\'evoluzione del marketing degli ultimi anni, nel pieno rispetto degli Standard ISO Non valutazioni parziali, ma una visione completa e integrata del valore del tuo brand.',
    },
    {
      icon: '🛡️',
      title: 'Perizia Veritiera e Difendibile',
      badge: 'CERTIFICATA',
      description: 'Le nostre perizie sono costruite con rigore metodologico e completa tracciabilità. Ogni valutazione è supportata da documentazione  essenziale per controlli fiscali, revisioni contabili e analisi legali.',
    },
    {
      icon: '📁',
      title: 'Area Documentale     Dedicata',
      description: 'Centralizziamo tutti i documenti strategici, fatture, strategie, perizie precedenti, KPI e valutazioni, in un\'area sicura e organizzata. Facilitiamo così la governance aziendale e semplifichiamo ogni futuro audit.',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Cosa Facciamo per il Tuo Brand
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Tre pilastri fondamentali che rendono Brand Capital l'unico partner di cui hai bisogno per valorizzare i tuoi asset intangibili
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {servizi.map((servizio, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl sm:text-5xl mb-4 sm:mb-6 text-center">{servizio.icon}</div>
              
              <div className="text-center mb-4">
                <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2">
                  {servizio.title}
                </h3>
                {servizio.badge && (
                  <div className="inline-block bg-green-100 text-green-700 text-xs font-bold px-3 py-1 rounded-full">
                    {servizio.badge}
                  </div>
                )}
              </div>
              
              <p className="text-sm lg:text-base text-gray-600 leading-relaxed text-center">
                {servizio.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}